import * as R from 'fp-ts/Record';
import * as A from 'fp-ts/Array';
import * as F from 'fp-ts/Function';
function transition_singleTransitionsFlat(transition) {
    return F.pipe(transition.singleTransitions, A.mapWithIndex((index, singleTransition) => ({
        fromNodeId: transition.fromNodeId,
        transitionId: transition.id,
        singleTransitionIndex: index,
        char: singleTransition.char,
    })));
}
function machine_singleTransitionsFlat(machine) {
    return F.pipe(machine.transitions, R.toArray, A.map(val => val[1]), 
    // Array aller Transitions
    A.map(transition_singleTransitionsFlat), 
    // Array, das für jede Transition ein Array aller SingleTransitionFlats enthält
    A.flatten);
}
const singleTransitionFlat_errors = (singleTransitionsFlat) => (singleTransitionFlat1) => {
    return F.pipe(singleTransitionsFlat, A.filter((singleTransitionFlat2) => singleTransitionFlat2 !== singleTransitionFlat1), 
    // alle TransitionsFlat, die nicht singleTransitionFlat1 sind
    A.filter((singleTransitionFlat2) => singleTransitionFlat1.char === singleTransitionFlat2.char), 
    // alle TransitionsFlat, die das gleiche Eingabezeichen verarbeiten wie singleTransitionFlat1
    A.map((singleTransitionFlat2) => ({
        type: 'SingleTransitionError',
        transitionId1: singleTransitionFlat1.transitionId,
        singleTransitionIndex1: singleTransitionFlat1.singleTransitionIndex,
        transitionId2: singleTransitionFlat2.transitionId,
        singleTransitionIndex2: singleTransitionFlat2.singleTransitionIndex,
    })));
};
const errorsFromNode = (singleTransitionsFlat) => (node) => {
    const singleTransitionsFlatFromNode = singleTransitionsFlat.filter(singleTransitionFlat => singleTransitionFlat.fromNodeId === node.id);
    return F.pipe(singleTransitionsFlatFromNode, A.map(singleTransitionFlat_errors(singleTransitionsFlatFromNode)), A.flatten);
};
export function mealyMachine_errors(machine) {
    const singleTransitionsFlat = machine_singleTransitionsFlat(machine);
    let errors = F.pipe(machine.nodes, R.toArray, A.map(val => val[1]), A.map(errorsFromNode(singleTransitionsFlat)), A.flatten);
    return errors;
}
export function machineStateMealy_errors(machineState) {
    return Object.assign(Object.assign({}, machineState), { errors: mealyMachine_errors(machineState.machine) });
}
export function machineState_errors(machineState) {
    if (machineState.type === 'MachineStateMealy') {
        return machineStateMealy_errors(machineState);
    }
    else {
        return machineState;
    }
}
